import React from 'react';
import { Row, Col, Typography } from 'antd';
import hospitalLocationAPI from 'services/lab_request/hospitalLocation';
import hospitalPhysiciansAPI from 'services/lab_request/hospitalPhysicians';
import { LR_PERSONAL_INFO, LR_OTHER_INFO } from 'modules/main/lab_request/steps/constants';
import  moment  from "moment";

import './section.css';

const { Text } = Typography;

const leftSectionLayout = {
	sm: { span: 12 },
	lg: { span: 6 },
};

const rightSectionLayout = {
	sm: { span: 12 },
	lg: { span: 10 },
};


class SummarySection extends React.Component {
	state = {
		personalInfo: {
			givenName: '',
			nameSuffix: '',
			lastName: '',
			middleName: '',
			dateOfBirth: '',
			sex: '',
		},
		otherInfo: {
			bed: '',
			chargeSlip: '',
			comment: '',
			locationID: '',
			locationName: '',
			officialReceipt: '',
			patientAge: '',
			patientID: '',
			physicianID: '',
			physicianName: '',
			visit: ''
		}
	}

	
	async componentDidMount() {
		const { personalInfo, otherInfo } = this.state;
		const sessPersInfo = JSON.parse(sessionStorage.getItem(LR_PERSONAL_INFO)) || personalInfo;
		const sessOtherInfo = JSON.parse(sessionStorage.getItem(LR_OTHER_INFO)) || otherInfo;

		const hospitalLocations = await hospitalLocationAPI();
		const physicians = await hospitalPhysiciansAPI();
		
		const location = hospitalLocations.find(loc => loc.locationID === sessOtherInfo.locationID);
		const physician = physicians.find(phys => phys.physicianID === sessOtherInfo.physicianID); 	
		
		this.setState(() => ({ 
			personalInfo: sessPersInfo,
			otherInfo: { 
				...sessOtherInfo, 
				locationName: location ? location.name : '',
				physicianName: physician 
					? `${[undefined, null, ''].includes(physician.namePrefix) ? '' : physician.namePrefix} ${physician.givenName} ${physician.lastName}`
					: '' 
			} 
		}));
	}

	render() {
		const {
			givenName,
			nameSuffix,
			lastName,
			middleName,
			dateOfBirth,
			sex
		} = this.state.personalInfo;
		
		const {
			bed,
			chargeSlip,
			comment,
			locationName,
			patientAge,
			physicianName,
			visit,
			patientID,
			officialReceipt
		} = this.state.otherInfo;

		const formatSystemDate = (date = new Date()) => {
		const pad = n => String(n).padStart(2, '0');
		const MM = pad(date.getMonth() + 1);
		const DD = pad(date.getDate());
		const YYYY = date.getFullYear();
		const HH = pad(date.getHours());
		const mm = pad(date.getMinutes());
		const ss = pad(date.getSeconds());
		return `${MM}-${DD}-${YYYY} ${HH}:${mm}:${ss}`;
		}

		// const requestDate =  moment().format("MM-DD-YYYY HH:MM:SS");
		const requestDate = formatSystemDate();

		return (
			<div className="request-summary">
				<Row justify="center">
								<Text strong style={{ fontSize: 18 }}>
									REQUEST SUMMARY
								</Text>
					</Row>
				<Row justify="center" style={{marginLeft: 80, marginTop: 30}}>
					<Col sm={10} /*lg={{ span: 18, offset: 3 }}*/>
						
						<Row >
							<Col {...leftSectionLayout}>
								<Text strong>PATIENT NAME</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{`${givenName} ${(middleName === undefined || middleName === null ? '' : middleName)} ${lastName} ${nameSuffix || ''}`}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>DATE OF BIRTH</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{`${dateOfBirth} - ${patientAge} YEARS OLD`}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>GENDER</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{sex.toString().toUpperCase()}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>WARD/ROOM</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{locationName.toString().toUpperCase()}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>PATIENT ID</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{patientID}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>COMMENT</Text> 
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{comment ? comment.toString().toUpperCase() : '----'} </Text>
							</Col>
						</Row>
					</Col>
					<Col sm={10} /*lg={{ span: 18, offset: 3 }}*/>
					<Row>
							<Col {...leftSectionLayout}>
								<Text strong>REQUEST DATE</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{requestDate}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>PHYSICIAN</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{physicianName ? physicianName.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>BED</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{bed ? bed.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>VISIT</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{visit ? visit.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>CHARGE SLIP</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{chargeSlip ? chargeSlip.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
						<Row>
							<Col {...leftSectionLayout}>
								<Text strong>OFFICIAL RECEIPT</Text>
							</Col>
							<Col {...rightSectionLayout}>
								<Text>{officialReceipt ? officialReceipt.toString().toUpperCase() : '----'}</Text>
							</Col>
						</Row>
					</Col>
					{/* <Col style={{marginLeft: "8.2%", width: "100%"}}>
						<Text strong>COMMENT</Text> 
						<Text style={{marginLeft: "5%"}}>{comment ? comment.toString().toUpperCase() : '----'}</Text>
					</Col> */}
				</Row>
			</div>
		);
	}
}

export default SummarySection;
